/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Sync progress" |
*
* @param {Event_Group_Sync_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_progress_label = /** @type {((inputs?: Event_Group_Sync_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sync progress")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sync progress")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sync progress")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Sync progress")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sync progress")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Sync progress")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Sync progress")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Sync progress")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sync progress")
	return /** @type {LocalizedString} */ ("Sync progress")
});